import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ScoreDistribution;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/* eslint-disable no-unused-vars */
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuintileDistribution from '../../../../charts/QuintileDistribution';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/format-message';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import Legend from '../../../../charts/Legend';
import { number } from 'sinon/lib/sinon/match';
import { withStyleOverrides } from '@instructure/quiz-common';
export var ScoreDistribution = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ScoreDistribution = /*#__PURE__*/function (_Component) {
  function ScoreDistribution() {
    var _this2;
    _classCallCheck(this, ScoreDistribution);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ScoreDistribution, [].concat(args));
    _defineProperty(_this2, "calculateLabelForColumnsWithExtremeValues", function (index, length) {
      if (index === 0) {
        return t('< 0%');
      }
      if (index === length - 1) {
        return t('> 100%');
      }
      return _this2.calculateLabelForColumns(index - 1, length - 2);
    });
    _defineProperty(_this2, "calculateLabelForColumns", function (index, length) {
      var label = Math.floor(index * 100 / length);
      return t('{label, number}%', {
        label: label
      });
    });
    return _this2;
  }
  _inherits(ScoreDistribution, _Component);
  return _createClass(ScoreDistribution, [{
    key: "render",
    value: function render() {
      var decileDistribution = this.props.decileDistribution;
      return jsx(React.Fragment, null, jsx("div", {
        css: this.props.styles.headingContainer
      }, jsx(Heading, {
        level: "h3",
        themeOverride: {
          h3FontWeight: 700
        }
      }, t('Score Distribution'))), jsx(QuintileDistribution, {
        animateDelay: 1000,
        animateDuration: 1000,
        visualDistribution: decileDistribution || [],
        calculateLabelForColumn: decileDistribution.length > 10 ? this.calculateLabelForColumnsWithExtremeValues : this.calculateLabelForColumns
      }), jsx("div", {
        "aria-hidden": "true",
        css: this.props.styles.chartLabel
      }, jsx(Text, {
        size: "small"
      }, t('Score'))), jsx("div", {
        css: this.props.styles.legendContainer
      }, jsx(Legend, {
        series: [{
          customStyles: this.props.styles.legendRect,
          label: t('Number of Students')
        }]
      })));
    }
  }]);
}(Component), _defineProperty(_ScoreDistribution, "displayName", 'ScoreDistribution'), _defineProperty(_ScoreDistribution, "componentId", "Quizzes".concat(_ScoreDistribution.displayName)), _defineProperty(_ScoreDistribution, "propTypes", {
  decileDistribution: PropTypes.arrayOf(PropTypes.number),
  styles: PropTypes.object
}), _defineProperty(_ScoreDistribution, "defaultProps", {
  decileDistribution: []
}), _ScoreDistribution)) || _class);